import { Navigate, useParams } from 'react-router-dom';
import { Status } from '../../hooks/useFetch';
import { useSourceMarket } from '../../hooks/useSourceMarket';
import { SourceMarketFields } from '@aviation/catering-masterdata-sdk';

export interface IRequireFeatureProps {
    flag: keyof SourceMarketFields;
    children: JSX.Element;
}

// Guards a route so it's only reachable when the given SourceMarket feature flag is enabled
// for the current client, redirecting back to the dashboard otherwise (e.g. direct URL access).
function RequireFeature(props: IRequireFeatureProps) {
    const { clientCode } = useParams();
    const { status, sourceMarket } = useSourceMarket(clientCode);

    if(status !== Status.Fetched)
        return null;

    if(!sourceMarket?.[props.flag])
        return <Navigate to={`/${clientCode}`} replace />;

    return props.children;
}

export default RequireFeature;
